import React from "react";
import { inject, observer } from "mobx-react";
import Dropdown from "component/atoms/Dropdown";
/// Message Modules
import SVGIcons from "assets/icon";

/**
 * 정의된 프로퍼티/상태 없음. 기본 DIV Attribute는 전달
 *
 * @interface IMeasureDropdownMenuPros    { Nothing }
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
// interface IMeasureDropdownMenuPros extends HTMLAttributes<HTMLDivElement> {}

/**
 * @description Contrast 버튼 클릭시 나타나는 확장 메뉴. UI Component Container
 * @function ContrastDropdownMenu
 */
@inject("toolbarStore")
@inject("hotkeyStore")
@observer
class MeasureDropdownMenu extends React.PureComponent {
  renderDropdownMenu() {
    const { toolbarStore, hotkeyStore } = this.props;
    // FIXME : Dropdown에 Shortkey 출력을 위해 임시로 구현
    // Dropdown에 새로운 항목이 추가되면, 고쳐야할 곳이 여러곳이 발생하므로
    // 좋은 구조가 아님. 꼭 수정해야함
    const keymap = hotkeyStore.getKeysFromCommandName([
      "SELECT_LENGTH_MEASUREMENT_TOOL",
      "SELECT_RECTANGLE_MEASUREMENT_TOOL",
      "SELECT_ELLIPSE_MEASUREMENT_TOOL",
      "SELECT_PENCIL_MEASUREMENT_TOOL",
      "SELECT_ANGLE_MEASUREMENT_TOOL",
      "SELECT_COBBANGLE_MEASUREMENT_TOOL",
    ]);

    return (
      <Dropdown.Menu bsPrefix="dropdown-menu--toolbar">
        <Dropdown.Item
          key="length-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="1"
          hotkey={keymap["SELECT_LENGTH_MEASUREMENT_TOOL"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("length");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("length")}
          as="div"
          // value="length"
        >
          Length
        </Dropdown.Item>
        <Dropdown.Item
          key="rectangle-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="2"
          hotkey={
            keymap["SELECT_RECTANGLE_MEASUREMENT_TOOL"].toUpperCase() || ""
          }
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("rectangle");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("rectangle")}
          as="div"
          //value="rectangle"
        >
          Rectangle
        </Dropdown.Item>
        <Dropdown.Item
          key="ellipse-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="3"
          hotkey={keymap["SELECT_ELLIPSE_MEASUREMENT_TOOL"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("ellipse");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("ellipse")}
          as="div"
          // value="ellipse"
        >
          Ellipse
        </Dropdown.Item>
        <Dropdown.Item
          key="pencil-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="4"
          hotkey={keymap["SELECT_PENCIL_MEASUREMENT_TOOL"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("pencil");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("pencil")}
          as="div"
          // value="pencil"
        >
          Pencil
        </Dropdown.Item>
        <Dropdown.Item
          key="angle-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="5"
          hotkey={keymap["SELECT_ANGLE_MEASUREMENT_TOOL"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("angle");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("angle")}
          as="div"
          // value="angle"
        >
          Angle
        </Dropdown.Item>
        <Dropdown.Item
          key="cobb-angle-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="6"
          hotkey={
            keymap["SELECT_COBBANGLE_MEASUREMENT_TOOL"].toUpperCase() || ""
          }
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={(event) => {
            event.preventDefault();
            toolbarStore.activateMeasureTypeTool("cobb-angle");
          }}
          active={toolbarStore.isActiveMeasureTypeTool("cobb-angle")}
          as="div"
          // value="cobb-angle"
        >
          Cobb angle
        </Dropdown.Item>
      </Dropdown.Menu>
    );
  }
  render() {
    return <React.Fragment>{this.renderDropdownMenu()}</React.Fragment>;
  }
}

export default MeasureDropdownMenu;
